import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "Purity First", body: "Every batch is independently assayed for >99% purity and identity before it ever reaches a vial." },
  { n: "02", title: "Precision Dosing", body: "Each compound ships with a clear, single-sentence best-use and an easy starting protocol — no guesswork." },
  { n: "03", title: "Cold-Chain Integrity", body: "Lyophilized, sealed and cold-chain shipped so your research material arrives exactly as intended." },
];

export default function Manifesto() {
  return (
    <section id="protocol" className="relative py-28 md:py-40 max-w-7xl mx-auto px-6 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="text-[11px] tracking-[0.4em] uppercase text-[#00F0FF] mb-16 font-mono2"
      >
        // The Protocol
      </motion.p>

      <div className="space-y-20">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative grid md:grid-cols-[auto_1fr] gap-6 md:gap-16 items-start border-t border-white/10 pt-10"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="font-display font-black text-7xl md:text-9xl text-white/[0.06] leading-none select-none">{c.n}</span>
            <div className="max-w-2xl">
              <h3 className="font-display font-extrabold text-2xl md:text-4xl uppercase tracking-tight mb-4">{c.title}</h3>
              <p className="text-slate-400 font-mono2 text-sm md:text-base leading-relaxed">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
